import React from "react";
import { Box, Divider, Grid, Typography } from "@mui/material";

import type {
  AprendizajeEsperado,
  CriterioEvaluacion,
  ObjetivoGenerico,
} from "./types";

import StatusLine from "./leftTree/StatusLine";
import AprendizajeAccordion from "./leftTree/AprendizajeAccordion";

interface Props {
  aprendizajes: AprendizajeEsperado[];
  loadingAE: boolean;
  errorAE: string;

  criteriosByAE: Record<string, CriterioEvaluacion[]>;
  loadingCEByAE: Record<string, boolean>;
  errorCEByAE: Record<string, string>;

  objetivosByCriterio: Record<string, ObjetivoGenerico[]>;
  loadingOGByCriterio: Record<string, boolean>;
  errorOGByCriterio: Record<string, string>;

  expandedAE: Record<string, boolean>;
  expandedCE: Record<string, boolean>;
  onToggleAE: (aeId: string, next: boolean) => void;
  onToggleCE: (ceId: string, next: boolean) => void;

  fetchCEForAE: (aeId: string) => Promise<void>;
  fetchOGForCriterio: (criterioId: string) => Promise<void>;

  isOGSelected: (aeId: string, ceId: string, ogId: string) => boolean;
  toggleOGSelection: (aeId: string, ceId: string, ogId: string) => void;
}

const ObjectiveSelectLeftTree: React.FC<Props> = ({
  aprendizajes,
  loadingAE,
  errorAE,

  criteriosByAE,
  loadingCEByAE,
  errorCEByAE,

  objetivosByCriterio,
  loadingOGByCriterio,
  errorOGByCriterio,

  expandedAE,
  expandedCE,
  onToggleAE,
  onToggleCE,

  fetchCEForAE,
  fetchOGForCriterio,

  isOGSelected,
  toggleOGSelection,
}) => {
  const showEmptyAE =
    !loadingAE && !errorAE && (aprendizajes?.length ?? 0) === 0;

  return (
    <Grid
      item
      xs={12}
      md={7}
      sx={{
        borderRight: { xs: "none", md: "1px solid rgba(0,0,0,0.12)" },
        minHeight: 360,
        maxHeight: 360,
        overflow: "auto",
        backgroundColor: "#FFFFFF",
      }}
    >
      <Box sx={{ p: 1.5, pb: 0.5 }}>
        <Typography
          sx={{
            fontFamily: "Montserrat",
            fontSize: "1rem",
            fontWeight: 700,
            color: "#336B87",
            letterSpacing: 0.2,
          }}
        >
          APRENDIZAJES ESPERADOS
        </Typography>
      </Box>

      <Divider />

      <Box sx={{ p: 1.2 }}>
        <StatusLine
          size="md"
          loading={loadingAE}
          loadingText="Cargando aprendizajes esperados..."
          error={!loadingAE ? errorAE : ""}
          empty={showEmptyAE}
          emptyText="No hay aprendizajes esperados disponibles para este objetivo."
        />

        {!loadingAE &&
          !errorAE &&
          aprendizajes.map((ae) => {
            const isExpanded = Boolean(expandedAE[ae.id]);
            const loadingCE = Boolean(loadingCEByAE[ae.id]);
            const ceError = errorCEByAE[ae.id] ?? "";
            const criterios = criteriosByAE[ae.id] ?? [];

            return (
              <AprendizajeAccordion
                key={ae.id}
                ae={ae}
                expanded={isExpanded}
                onToggle={(next) => onToggleAE(ae.id, next)}
                onFetchCE={() => fetchCEForAE(ae.id)}
                criterios={criterios}
                loadingCE={loadingCE}
                errorCE={ceError}
                expandedCE={expandedCE}
                onToggleCE={onToggleCE}
                onFetchOG={fetchOGForCriterio}
                objetivosByCriterio={objetivosByCriterio}
                loadingOGByCriterio={loadingOGByCriterio}
                errorOGByCriterio={errorOGByCriterio}
                isOGSelected={isOGSelected}
                toggleOGSelection={toggleOGSelection}
              />
            );
          })}
      </Box>
    </Grid>
  );
};

export default ObjectiveSelectLeftTree;
